/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ input: NonNullable<unknown>, output: NonNullable<unknown> }} Uno_Settings_Model_PriceInputs */



/**
* | output |
* | --- |
* | "{input} input · {output} output per 1M tokens" |
*
* @param {Uno_Settings_Model_PriceInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const uno_settings_model_price = /** @type {((inputs: Uno_Settings_Model_PriceInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Uno_Settings_Model_PriceInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`${i?.input} Eingabe · ${i?.output} Ausgabe pro 1 Mio. Tokens`)
	return /** @type {LocalizedString} */ (`${i?.input} input · ${i?.output} output per 1M tokens`)
});